import dummy from "./SM/dummy.jpg";
import Harshith from "./SM/Harshith_SM.jpg";
import Hemang from "./SM/Hemang_SM.jpg";
import Anil from "./SM/Anil_SM (1).jpg";
import Rohith from "./SM/P.Rohith_SM.jpg";
import Rishav from "./SM/Rishav_SM.jpg";
import Hrushikesh from "./SM/Hrushikesh_SM.jpg";
import Iesa from "./SM/Iesa_SM.jpg";
import Hyndavi  from "./SM/HYNDAVI_SM copy.jpg";
import Jai from "./SM/Jai_SM.jpg";
import Vinay from "./SM/KadariVinay_SM.jpg";
import Jagadeesh from "./SM/Jagadeesh_SM.jpg";
import Kethana from "./SM/Kethana_SM.jpg";
import Satyam from "./SM/Satyam_SM.jpg";
import Aakanksh from "./SM/Aakanksh_SM.jpg";
import Bijoy from "./SM/Bijoy_SM.jpg";
import Devansh from "./SM/DEVANSH_SM.jpeg";
import Ashish from "./SM/Ashish_Anjaneyulu_SM.jpg";
import Srithanshu from "./SM/Srithanshu_SM.jpg";
import Keerthana from "./SM/Keerthana_SM.jpg";
import Muru from "./SM/Muru_SM.jpg";
import Barbiyal from "./SM/dummy.jpg";
import Charan from "./SM/Sai Charan_SM.jpg";




const studData = [
  // {
  //   name: "Abhinav",
  //   img: Abhinav,
  //   pos: "Student Member",
  // },
  {
    name: "Konchada Harshith Subudhi",
    img: Harshith,
    pos: "Student Member",
  },
  {
    name: "Hemang Raghavendra Kulkarni ",
    img: Hemang,
    pos: "Student Member",
  },
  {
    name: "Anil Dhaker",
    img: Anil,
    pos: "Student Member",
  },
  {
    name: "Palisetty Rohith",
    img: Rohith,
    pos: "Student Member",
  },
  {
    name: "Rishav Kumar ",
    img: Rishav,
    pos: "Student Member",
  },
  {
    name: "Racha Hrushikesh ",
    img: Hrushikesh,
    pos: "Student Member",
  },
  {
    name: "Md Iesa Ali Ahmed",
    img: Iesa,
    pos: "Student Member",
  },
  {
    name: "Bhukya Hyndavi ",
    img: Hyndavi,
    pos: "Student Member",
  },
  {
    name: "Jai Prakash Gupta",
    img: Jai,
    pos: "Student Member",
  },
  {
    name: "Kadari Vinay",
    img: Vinay,
    pos: "Student Member",
  },
  {
    name: "Jagadeesh kunta ",
    img: Jagadeesh,
    pos: "Student Member",
  },
  {
    name: "J.Kethana",
    img: Kethana,
    pos: "Student Member",
  },
  {
    name: "Satyam Sarthi ",
    img: Satyam,
    pos: "Student Member",
  },
  {
    name: "Aakanksh Reddy ",
    img: Aakanksh,
    pos: "Student Member",
  },
  // {
  //   name: "Samridhi Rastogi",
  //   img: dummy,
  //   pos: "Student Member",
  // },
  {
    name: "Bijoy sannyasi ",
    img: Bijoy,
    pos: "Student Member",
  },
  // {
  //   name: "Siddhi Datri ",
  //   img: dummy,
  //   pos: "Student Member",
  // },
  {
    name: "Devansh Agarwal",
    img: Devansh,
    pos: "Student Member",
  },
  {
    name: "Ashish Anjaneyulu  ",
    img: Ashish,
    pos: "Student Member",
  },
  {
    name: "Pinninti Srithanshu Reddy",
    img: Srithanshu,
    pos: "Student Member",
  },
  {
    name: "Sai Keerthana   ",
    img: Keerthana,
    pos: "Student Member",
  },
  {
    name: "Irrinki Lakshmi Sai Charan",
    img: Charan,
    pos: "Student Member",
  },
  {
    name: "Muru Kambariya   ",
    img: Muru,
    pos: "Student Member",
  },
  {
    name: "Aashish Barbiyal   ",
    img: Barbiyal,
    pos: "Student Member",
  },
];

export default studData;
